import { Component, Input } from "@angular/core"

@Component({
    selector: "app-preloader",
    templateUrl: "./preloader.component.html",
    styleUrls: ["./preloader.component.less"],
})
export class PreloaderComponent {
    @Input() public colors: boolean = true
}
